import type { FC } from 'react';
import {
  Check,
  CheckAll,
  Clock,
  ExclamationTriangle,
  HourglassSplit,
} from 'react-bootstrap-icons';
import { MessageDeliveryStatus } from '../../../constants/generalData';
import { MessageStatusEnums } from '../../../modules/enums/status';

export interface Options {
  status?: string;
  read?: boolean;
}

export const DeliveryReceipt: FC<Options> = ({ status, read }) => {
  function mapToStatus(value?: string): keyof typeof MessageDeliveryStatus | undefined {
    if (!value) return undefined;
    const lower = value.toLowerCase();
    for (const key in MessageDeliveryStatus) {
      if (
        MessageDeliveryStatus[key as keyof typeof MessageDeliveryStatus].includes(lower)
      ) {
        return key as keyof typeof MessageDeliveryStatus;
      }
    }
    return undefined;
  }

  const normalizedStatus = mapToStatus(status);

  if (normalizedStatus === MessageStatusEnums.SENT) {
    return <Check />;
  } else if (normalizedStatus === MessageStatusEnums.REJECTED) {
    return <ExclamationTriangle color="red" />;
  } else if (normalizedStatus === MessageStatusEnums.SCHEDULED) {
    return <HourglassSplit />;
  } else if (normalizedStatus === MessageStatusEnums.CLOCK) {
    return <Clock />;
  } else if (
    normalizedStatus === MessageStatusEnums.DELIVERED ||
    normalizedStatus === MessageStatusEnums.READ ||
    read
  ) {
    const color =
      read || normalizedStatus === MessageStatusEnums.READ ? '#03cffc' : undefined;
    return <CheckAll color={color} />;
  } else {
    return <ExclamationTriangle color="yellow" />;
  }
};
